const reportColors = {
  GOOD: '#00fad2',
  AVERAGE: '#cfff76',
  POOR: '#ff3143',
};

const sortTypes = {
  NAME: 'name',
  SCORE: 'score',
};

function formatProgressReportData(reportData){
  let reformattedData = [];
  for(let i = 0; i < reportData.data.length; i++){
    let dataValue = reportData.data[i];
    if(!dataValue){
      reformattedData.push(null);
    } else {
      let poorCutoff = reportData.poorCutoff[i];
      let averageCutoff = reportData.averageCutoff[i] + poorCutoff;
      let markerColor = reportColors.POOR;
      if(dataValue > poorCutoff){
        markerColor = reportColors.AVERAGE;
      }
      if(dataValue > averageCutoff){
        markerColor = reportColors.GOOD;
      }
      let wrappedValue = {y: dataValue, marker: {fillColor: markerColor}};
      if(i == 0){
        wrappedValue.x = 0.15;  //bump the first data point over a bit so that it doesn't run off the edge
      }
      reformattedData.push(wrappedValue);

      if(i == 0){
        reformattedData.push(null); //TODO figure out why this hack is necessary
      }
    }
  }
  return Object.assign({}, reportData, {data: reformattedData});
}

export function getProgressReportConfig(reportData){
  if(!reportData){
    return {};
  }
  reportData = formatProgressReportData(reportData);
  return {
    chart:{
      //height: 300,
    },
    title:{
      text: null,
    },
    credits: {
      enabled: false
    },
    tooltip: {
      formatter: function() {
        return this.y + '';
      },
      backgroundColor: '#000000',
      borderColor: "#000000",
      style: {
        fontWeight: 'bold',
        color: "#ffffff",
      },
    },
    plotOptions: {
      series: {
        connectNulls: true,
      },
      line: {
        cursor: 'pointer',
        events: {
          click: function (event) {
            alert(
              this.name + ' clicked\n' +
              'value: ' + event.point.y
            );
          }
        },
        marker: {
          symbol: "circle",
          radius: 8,
          lineWidth: 4,
          lineColor: "white",
        },
        lineWidth: 4,
      },
      area: {
        stacking: 'normal',
        lineWidth: 0,
        marker: {
          enabled: false,
        },
      },
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      categories: ['Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
      min: 0.5,
      max: 10.5,
      plotLines: [{
        color: 'gray',
        width: 2,
        value: 3.5,
      },
      {
        color: 'gray',
        width: 2,
        value: 7.5,
      }],
    },
    yAxis: {
      title: {
        text: "Score",
      },
      min: 100,   //TODO: make these dynamic
      max: 150,
    },
    series: [
      {
        name: "Good",
        type: 'area',
        data: reportData && reportData.goodCutoff,
        color: reportColors.GOOD,
        enableMouseTracking: false,
      },
      {
        name: "Average",
        type: 'area',
        data: reportData && reportData.averageCutoff,
        color: reportColors.AVERAGE,
        enableMouseTracking: false,
      },
      {
        name: "Poor",
        type: 'area',
        data: reportData && reportData.poorCutoff,
        color: reportColors.POOR,
        enableMouseTracking: false,
      },
      {
        name: (reportData && reportData.studentName) + "'s performance",
        type: 'line',
        data: reportData && reportData.data,
        color: '#ffffff',
      },
    ],
  };
}

function formatBenchmarkReportData(reportData, sort){
  let scoreData = reportData.scoreData;
  let sortedScoreData = [];
  if(sort == sortTypes.NAME){
    sortedScoreData = sortByName(scoreData);
  } else {
    sortedScoreData = sortByScore(scoreData);
  }
  let scores = [];
  let names = [];
  let markers = [];
  for(let i = 0; i < sortedScoreData.length; i++){
    let dataPoint = sortedScoreData[i];
    scores.push(dataPoint.score);
    names.push(dataPoint.name);
    if(dataPoint.marker){
      markers.push([i, dataPoint.marker]);
    }
  }
  let newReportData = Object.assign({}, reportData, {
    scores: scores,
    markers: markers,
    studentNames: names,
  });
  return newReportData;
}

function sortByScore(scores){
  let compare = function (score1, score2) {
    return score2.score - score1.score;
  }
  return scores.sort(compare);
}

function sortByName(scores){
  let compare = function (score1, score2) {
    if (score2.name < score1.name){
      return 1;
    } else if (score2.name > score1.name){
      return -1;
    } else {
      return 0;
    }
  }
  return scores.sort(compare);
}

export function getBenchmarkReportConfig(reportData, sort, history){
  if(!reportData){
    return {};
  }
  reportData = formatBenchmarkReportData(reportData, sort);

  return {
    chart: {
      //type: 'bar'
    },
    title: {
      text: null,
    },
    tooltip: {

    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        },
        zoneAxis: 'y',
        zones: [{
          value: reportData.poorCutoff,
          color: reportColors.POOR,
        }, {
          value: reportData.averageCutoff,
          color: reportColors.AVERAGE,
        }, {
          color: reportColors.GOOD,
        }],
        cursor: 'pointer',
        events: {
          click: function (event) {
            history.push("/teacher/reports/progress/123456");
          }
        },
      },
      scatter: {
        marker: {
          symbol: 'url(/src/images/bacon.svg)',
          width: 40,
          height: 40,
          lineWidth: 4,
          lineColor: "blue",
        },
      }
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: reportData.studentNames,
      title: {
        text: null
      }
    },
    yAxis: {
      min: 0,
      plotLines: [{
        color: 'gray',
        width: 2,
        value: reportData.cutLine,
        dashStyle: 'dot',
      }],
      title: {
        text: 'score',
        align: 'high'
      },
      labels: {
        overflow: 'justify'
      }
    },
    series: [{
      type: 'bar',
      name: 'ORF scores',
      data: reportData.scores,
    },
    {
     type: 'scatter',
     name: 'markers',
     data: reportData.markers,
    }],
  };
}